import { NavLink } from "@remix-run/react";
import { classNames, getIconUrl, prettyValue, roundALR } from "~/lib/util";
import PopoverAPY from "./popover-apy";
import TransactionButton from "./transaction-button";
import { generateCloseIgnitionManifest } from "~/lib/ignition";
import { useRadix } from "~/rdt/radixProvider";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);

const DEX = {
  'plaza': 'DefiPlaza',
  'caviar': 'Caviarnine',
  'oci': 'Ociswap'
}

const ICONS = {
  'xUSDC': 'https://assets.instabridge.io/tokens/icons/xUSDC.png',
  'xUSDT': 'https://assets.instabridge.io/tokens/icons/xUSDT.png',
  'xETH': 'https://assets.instabridge.io/tokens/icons/xETH.png',
  'xwBTC': 'https://assets.instabridge.io/tokens/icons/xwBTC.png'
}

export function IgnitionLiquidity({ pairs, account }) {
  const { sendTransaction } = useRadix();

  function onRemove(row) {
    console.log('🫡', row.localId)
    const transactionManifest = generateCloseIgnitionManifest(account, row.localId.localId, row.localId.dex);

    sendTransaction(transactionManifest, `Remove ${prettyValue(row.amount)} ${row.resourceName} from DefiPlaza Ignition 🚀`);
  }

  return (
    <div className="dark:bg-background-900 grow rounded-xl bg-white p-4 lg:rounded-2xl lg:p-8">
      {pairs.length ? (
        <table className="min-w-full divide-y divide-gray-300">
          <thead className="dark:text-primary-100 text-primary-800">
            <tr>
              <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-0">
                Token
              </th>
              <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-0">
                DEX
              </th>
              <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold sm:table-cell">
                Locked until
              </th>
              <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold sm:table-cell">
                Deposit
              </th>
              <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold sm:table-cell">
                Returned
              </th>
              <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold sm:table-cell">
                ROI
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0"></th>
            </tr>
          </thead>
          <tbody className="divide-primary-300 divide-y">
            {pairs.map((row) => {
              // const share = +row.amount / +row.lpToken.totalSupply;
              // const apy = row.isBase ? row.pair.baseAPY : row.pair.quoteAPY;

              return (
                <>
                  <tr key={row.address} className="dark:hover:bg-background-900 hover:bg-neutral-200">
                    <td className="w-full max-w-0 py-4 pl-4 pr-3 font-bold sm:w-auto sm:max-w-none sm:pl-0">
                      <div className="flex items-center">
                        <div className="h-8 w-8">
                          <img className="bg-background-900 h-8 w-8 rounded-full" src={ICONS[row.resourceName]} alt="" />
                        </div>
                        <div className="ml-4 text-black dark:text-white">{row.resourceName}</div>
                      </div>
                    </td>
                    <td className="py-4 pl-4 pr-3 font-bold sm:w-auto sm:max-w-none sm:pl-0">
                      {DEX[row.postionId]}
                    </td>
                    <td className={classNames(row.isBase ? "text-primary-700 dark:text-white" : "dark:dark:text-primary-200 text-black", "hidden px-3 py-4 font-medium lg:table-cell")}>
                      {dayjs(row.maturityDate).format('lll')}
                    </td>
                    <td className={classNames(row.isBase ? "dark:dark:text-primary-200 text-black" : "text-primary-700 dark:text-white", "hidden px-3 py-4 font-medium lg:table-cell")}>
                      {prettyValue(row.userContribution)} {row.resourceName}
                    </td>
                    <td className={classNames("dark:dark:text-primary-200 hidden px-3 py-4 font-medium text-black lg:table-cell")}>
                      <span className="text-primary-700 dark:text-white">{row.returnedResources.filter(r => r.resource == row.resourceName).map(r => `${prettyValue(r.amount)} ${r.resource}`)}</span>{' + '}
                      {row.returnedResources.filter(r => r.resource !== row.resourceName).map(r => `${prettyValue(r.amount)} ${r.resource}`)}
                    </td>
                    <td className={classNames("dark:dark:text-primary-200 hidden px-3 py-4 font-medium text-black lg:table-cell")}>{row.roi}</td>
                    {/* <td className={classNames("dark:dark:text-primary-200 hidden px-3 py-4 font-medium text-black lg:table-cell")}>{roundALR(row.Pair.baseAPY)}%</td> */}
                    <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                      {dayjs(row.maturityDate).isBefore(dayjs()) ? (<TransactionButton title="Remove" onClick={() => onRemove(row)} />) : <p className="btn-primary-table text-center">Locked</p>}
                    </td>
                  </tr>

                  <tr className="border-b-primary-200 border-b lg:hidden">
                    <td colSpan={3}>
                      <div className="grid grid-cols-2 gap-4 px-3 py-4 ">
                        <p className={classNames(row.isBase ? "text-primary-700 dark:text-white" : "dark:dark:text-primary-200 text-black", "font-medium")}>
                          <span className="text-sm">Locked until</span>
                          <br />
                          <span>{dayjs(row.maturityDate).format('lll')}</span>
                        </p>
                        <p className={classNames("dark:dark:text-primary-200 font-medium text-black")}>
                          <span className="text-sm">ROI</span>
                          <br />
                          <span>{row.roi}</span>
                        </p>

                        <p className={classNames(row.isBase ? "dark:dark:text-primary-200 text-black" : "text-primary-700 dark:text-white", "font-medium")}>
                          <span className="text-sm">Deposit</span>
                          <br />
                          <span>
                            {prettyValue(row.userContribution)} {row.resourceName}
                          </span>
                        </p>
                        <p className={classNames("dark:dark:text-primary-200 font-medium text-black")}>
                          <span className="text-sm">Returned</span>

                          <br />
                          <span className="text-primary-700 dark:text-white">{row.returnedResources.filter(r => r.resource == row.resourceName).map(r => `${prettyValue(r.amount)} ${r.resource}`)}</span>{' + '}
                          {row.returnedResources.filter(r => r.resource !== row.resourceName).map(r => `${prettyValue(r.amount)} ${r.resource}`)}
                        </p>

                      </div>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p className="text-primary-100 rounded-xl p-20 text-center lg:rounded-2xl">Your Project Ignition positions will appear here.</p>
      )}
    </div>
  );
}
